<template>
    <div>
        <div class="modal-card" style="width: auto">
            <header class="modal-card-head">
                <p class="modal-card-title">Change Password</p>                
            </header>
            
        <section class="modal-card-body">

            <div class="row">
                    <b-field :label="'Current Password'">
                        <b-input custom-class="binput" @keyup.enter.native="changePassword" type="password" v-model.trim="currentPassword">
                        </b-input>
                    </b-field>
                    <b-field :label="'New Password'">
                        <b-input custom-class="binput" @keyup.enter.native="changePassword" type="password" v-model.trim="newPassword">
                        </b-input>
                    </b-field>
                    <b-field :label="'Confirm Password'">
                        <b-input custom-class="binput" @keyup.enter.native="changePassword" type="password" v-model.trim="reTypePassword">
                        </b-input>
                    </b-field>

                    
            </div>
            <div class="row">
                &nbsp;
            </div>
            <div class="row">
                <a @click="changePassword" class="button is-medium is-fullwidth is-primary">Submit</a>
                
            </div>

        </section>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            currentPassword: '',
            newPassword: '',
            reTypePassword: ''
        }
    },
    methods: {
        changePassword() {
            
            if(this.currentPassword.length == 0) {
                this.$store.commit('setAlertBox', {title: 'Error', message: 'enter old password'})
                return
            }
            if(this.newPassword.length == 0) {
                this.$store.commit('setAlertBox', {title: 'Error', message: 'enter new password'})
                return
            }

            if(this.newPassword != this.reTypePassword) {
                this.$store.commit('setAlertBox', {title: 'Error', message: 'new and confirm password donot match'})
                return
            }

            this.$store.dispatch('changePassword', 
                {currentPassword: this.currentPassword, newPassword: this.newPassword, reTypePassword: this.reTypePassword})
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/modules/UserProfile/Index.vue